import { Box, Button, HStack, Icon, Stack, Text } from '@chakra-ui/react';
import { ICONS } from '~/constants';
import { Link } from '@chakra-ui/next-js';
import { ListSkeleton } from '~/components/homes/list/components/ListSkeleton';
import { Database } from '@habity/types';
import { getMapsUrl } from '@habity/utils';

type Place = Database['public']['Tables']['places']['Row'];

interface PlaceCardDataProps {
  place: Place;
  isLoading?: boolean;
  variant?: 'default' | 'compact';
}

export const PlaceCardData = ({
  place,
  isLoading = false,
  variant = 'default',
}: PlaceCardDataProps) => {
  const { name, street, zip, city, latitude, longitude } = place || {};

  return (
    <Stack spacing="2" p={5} cursor="pointer" justifyContent="flex-start">
      {/* Address */}
      <ListSkeleton isLoaded={!isLoading}>
        <Box mt="1">
          <HStack spacing="4" justifyContent="flex-start" alignItems="top">
            <Icon
              as={ICONS.LOCATION_PIN}
              color="blackAlpha.900"
              boxSize="48px"
            />

            <Stack spacing="1">
              <Text size={{ mobile: 'lg', desktop: 'xl' }} fontWeight="medium">
                {getPlaceAddressLabel(place)}
              </Text>
              {name && (
                <Text size="sm" color="gray.600">
                  {name}
                </Text>
              )}

              {/* Buttons */}
              <HStack mt={2}>
                {/* Map button */}
                {latitude && longitude && (
                  <Link
                    href={getMapsUrl({ street, zip, city })}
                    target="_blank"
                  >
                    <Button
                      variant="secondary"
                      size="sm"
                      fontSize="sm"
                      leftIcon={<Icon as={ICONS.SHARE} boxSize="10px" />}
                      px={5}
                    >
                      Se på karta
                    </Button>
                  </Link>
                )}
              </HStack>
            </Stack>
          </HStack>
        </Box>
      </ListSkeleton>

      {/* Location Info */}
      {/* <ListSkeleton isLoaded={!isLoading}>
        <Stack h="46px" spacing="1">
          <HStack spacing="1" justifyContent="flex-start">
            <Icon as={ICONS.LOCATION_PIN} color="teal.500" boxSize="12px" />
            <Text
              size="sm"
              lineHeight={1.2}
              noOfLines={1}
              color="blackAlpha.700"
            >
              {city}
              {country && country !== 'SE' && `, ${country}`}
            </Text>
          </HStack>

          {latitude && longitude && (
            <HStack spacing="1" justifyContent="flex-start">
              <Text size="xs" lineHeight={1.2} noOfLines={1} color="gray.500">
                {latitude.toFixed(6)}, {longitude.toFixed(6)}
              </Text>
            </HStack>
          )}
          
             {telephone && (
            <HStack spacing="1" justifyContent="flex-start">
              <Link
                href={`tel:${telephone}`}
                color="blackAlpha.700"
                _hover={{ color: 'black', textDecoration: 'underline' }}
              >
                <Text size="sm" lineHeight={1.2} noOfLines={1}>
                  Telefon {telephone}
                </Text>
              </Link>
            </HStack>
          )}

          {email_address && (
            <HStack spacing="1" justifyContent="flex-start">
              <Link
                href={`mailto:${email_address}`}
                color="blackAlpha.700"
                _hover={{ color: 'black', textDecoration: 'underline' }}
              >
                <Text size="sm" lineHeight={1.2} noOfLines={1}>
                  {email_address}
                </Text>
              </Link>
            </HStack>
          )}
        </Stack>
      </ListSkeleton> */}
    </Stack>
  );
};

export function getPlaceAddressLabel(place: Place) {
  const { street, zip, city } = place || {};

  if (!street && !zip && !city) {
    return 'Okänd adress';
  }

  const parts = [];
  if (street) parts.push(street);
  if (zip && city) {
    parts.push(`${zip} ${city}`);
  } else if (zip) {
    parts.push(zip);
  } else if (city) {
    parts.push(city);
  }

  return parts.join(', ');
}
